import { z } from 'zod';

export const categorySchema = z.object({
  name: z.string().min(1, 'Category name is required').max(100, 'Category name is too long'),
  icon: z.string().nullable().optional(),
  status: z.string().nullable().optional(),
});

export type CategoryFormValues = z.infer<typeof categorySchema>;
